module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/accessories-3bb956827050ddf003032f9abab4a7ad.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/accessories.png
// module id = 3XHX
// module chunks = 12 16 18